module.exports = __webpack_public_path__ + "img/full7-min.db2903b1.png";